import ActionsForm from '@/shared/mixins/actionsForm'
import templateTable from './components/templateTable/templateTable.vue'
import templateFilter from '../TemplateFilter/templateFilter.vue'
import panelTemplate from '../detailsTemplate/panelTemplate/panelTemplate.vue'
import tabsTemplate from '../detailsTemplate/tabsTemplate/tabsTemplate.vue'

export default {
  name: 'templateQmaPIVS',
  components: {templateTable, templateFilter, tabsTemplate, panelTemplate},
  mixins: [ActionsForm],
  data () {
    return {
      details: false,
      templateid: null,
      tipoTemplate: null,
      TipoQmaTemplate: 'PIVS'
    }
  },
  methods: {
    search (data) {
      this.$refs.tablepivs.formSearch = data
      this.$refs.tablepivs.onLoad()
    },
    recarregarTemplateEdicao () {
    },
    atualizaPainel () {
      this.$refs.painel.onLoad()
    },
    templateQMADetalhes (value) {
      this.details = true
      this.tipoTemplate = value.tipoTemplate
      this.templateid = value.id
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/templateQmaPIVS/templateQmaPIVS.js